/* Bee Nattu — tema Shopify. Carrinho nativo (/cart.js), desconto progressivo, cupom, brindes, frete. */
(function () {
  'use strict';
  var BN = window.BeeNattu || {};
  var R = BN.routes || { cartAdd: '/cart/add', cartChange: '/cart/change', cartUpdate: '/cart/update', cart: '/cart' };
  var VOL2 = (BN.volume2 || 'VOLUME10').toUpperCase();
  var VOL3 = (BN.volume3 || 'VOLUME15').toUpperCase();
  var VOLUME = [VOL2, VOL3];
  var COUPON_KEY = 'bn_coupon';
  var FREE = parseFloat(String(BN.freeShipping || '169.90').replace(',', '.')) || 169.9;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- helpers ---------- */
  function formatMoney(cents) {
    var fmt = BN.moneyFormat || 'R$ {{amount_with_comma_separator}}';
    var v = (Number(cents) / 100);
    var withComma = v.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    var withDot = v.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_with_comma_separator') return withComma;
      if (k === 'amount_no_decimals_with_comma_separator') return Math.round(v).toString();
      if (k === 'amount_no_decimals') return Math.round(v).toString();
      return withDot;
    });
  }
  function toast(msg) {
    var t = $('#bn-toast'); if (!t) return;
    t.textContent = msg; t.classList.add('is-show');
    clearTimeout(t._h); t._h = setTimeout(function () { t.classList.remove('is-show'); }, 3200);
  }
  function api(url, body) {
    var opts = body ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) } : { headers: { Accept: 'application/json' } };
    return fetch(url, opts).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) { var e = new Error(j.description || j.message || 'Erro'); e.data = j; throw e; } return j; });
    });
  }
  function getCart() { return api(R.cart + '.js'); }
  function getCoupon() { try { return localStorage.getItem(COUPON_KEY) || ''; } catch (e) { return ''; } }
  function setCoupon(c) { try { c ? localStorage.setItem(COUPON_KEY, c) : localStorage.removeItem(COUPON_KEY); } catch (e) {} }
  function cartCodes(cart) { return (cart.discount_codes || []).map(function (d) { return String(d.code).toUpperCase(); }); }
  /* Kit e adicionais já têm preço de oferta: não recebem desconto progressivo. */
  function isOfferCart(cart) {
    return (cart.items || []).some(function (i) {
      var h = String(i.handle || '');
      return h.indexOf('kit-') === 0 || h.indexOf('adicional-') === 0;
    });
  }
  function hasGiftLine(cart) { return (cart.items || []).some(function (i) { return i.properties && i.properties.Brinde; }); }

  /* ---------- discount sync (mesma regra do site) ---------- */
  // 1 item: cupom manual (se houver). 2 itens: VOLUME10. 3+: VOLUME15. Cupom manual some com 2+ itens.
  function desiredCode(cart) {
    var n = cart.item_count;
    if (isOfferCart(cart)) return n === 1 ? getCoupon() : '';
    if (n >= 3) return VOL3;
    if (n === 2) return VOL2;
    if (n === 1) return getCoupon();
    return '';
  }
  function syncDiscounts(cart) {
    var n = cart.item_count;
    var manual = getCoupon();
    if (n >= 2 && manual) {
      setCoupon('');
      toast(isOfferCart(cart) ? 'Cupons valem só para 1 item.' : 'Cupons valem só para 1 item. Aplicamos o desconto progressivo.');
    }
    if (n === 0 && manual) setCoupon('');
    var want = desiredCode(cart);
    var have = cartCodes(cart);
    var ok = want ? (have.length === 1 && have[0] === want.toUpperCase()) : have.length === 0;
    if (ok) return Promise.resolve(cart);
    return api(R.cartUpdate + '.js', { discount: want }).catch(function () { return cart; });
  }

  /* ---------- entregar o cupom ao checkout externo (Bestfy) ---------- */
  /* O Bestfy substitui o checkout da Shopify. O parametro `discount` de
     /cart/update.js e NAO documentado: ele preenche cart.discount_codes e
     acerta o total exibido, mas o desconto so vira preco quando o checkout
     DA SHOPIFY roda o motor de descontos — o que nunca acontece aqui.
     Por isso o cupom aparece na gaveta e some no Bestfy.

     Solucao: publicar o codigo em dois canais que existem ANTES do checkout,
     sem interceptar o botao (o bestfy-checkout-redirect.js ja escuta ali;
     um segundo listener criaria corrida e poderia travar o redirect). */

  var primedCode = '';

  function activeCode(cart) {
    var ok = (cart.discount_codes || []).filter(function (d) { return d.applicable; });
    if (ok.length) return String(ok[0].code).toUpperCase();
    var want = desiredCode(cart);
    return want ? String(want).toUpperCase() : '';
  }

  /* Canal 1 — atributos do carrinho: aparecem em /cart.js, na Storefront API
     e no proprio pedido. E por onde um checkout externo consegue ler. */
  function syncCheckoutAttrs(cart) {
    var code = activeCode(cart);
    var amount = code ? ((cart.total_discount || 0) / 100).toFixed(2) : '';
    var a = cart.attributes || {};
    if ((a.discount_code || '') === code && (a.discount_amount || '') === amount) {
      return Promise.resolve(cart);
    }
    return api(R.cartUpdate + '.js', {
      attributes: { discount_code: code, discount_amount: amount }
    }).catch(function () { return cart; });
  }

  /* Canal 2 — cookie oficial de desconto (/discount/CODIGO). E o mecanismo
     documentado da Shopify e sobrevive ao redirect para fora do dominio. */
  function primeDiscountCookie(code) {
    if (!code) { primedCode = ''; return Promise.resolve(); }
    if (code === primedCode) return Promise.resolve();
    primedCode = code;
    return fetch('/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(R.cart), {
      credentials: 'same-origin'
    }).catch(function () { primedCode = ''; });
  }

  /* Roda a cada mudanca do carrinho — nunca no clique do checkout. */
  function publishDiscount(cart) {
    return syncCheckoutAttrs(cart).then(function (updated) {
      var c = (updated && updated.items) ? updated : cart;
      return primeDiscountCookie(activeCode(c)).then(function () { return c; });
    }).catch(function () { return cart; });
  }

  /* ---------- cart drawer ---------- */
  var drawer, busy = false;
  function setBusy(b) { busy = b; if (drawer) drawer.classList.toggle('is-busy', b); var cb = $('[data-checkout-btn]'); if (cb) cb.disabled = b; }
  function openDrawer() { if (!drawer) return; drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; refresh(); }
  function closeDrawer() { if (!drawer) return; drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }

  function render(cart) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; el.hidden = cart.item_count === 0; });
    if (!drawer) return;
    var items = $('[data-cart-items]', drawer), foot = $('[data-cart-foot]', drawer);
    $('[data-cart-summary]', drawer).textContent = cart.item_count === 0 ? 'Seu carrinho está vazio' : cart.item_count + (cart.item_count === 1 ? ' item' : ' itens') + ' no carrinho';

    var fs = $('[data-free-shipping]', drawer), total = cart.total_price / 100;
    if (cart.item_count === 0) { fs.innerHTML = ''; }
    else if (total >= FREE) { fs.innerHTML = '🎉 Você ganhou <strong>frete grátis</strong>!<div class="bar"><i style="width:100%"></i></div>'; }
    else { fs.innerHTML = 'Faltam <strong>' + formatMoney(Math.ceil((FREE - total) * 100)) + '</strong> para frete grátis<div class="bar"><i style="width:' + Math.min(100, total / FREE * 100) + '%"></i></div>'; }

    renderUpsell(cart, total);

    if (cart.item_count === 0) {
      items.innerHTML = '<div class="drawer__empty"><svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z"/><path d="M3 6h18"/><path d="M16 10a4 4 0 0 1-8 0"/></svg><p>Seu carrinho está vazio</p><a class="btn btn--pill btn--sm" href="/collections/all">Ver produtos</a></div>';
      foot.hidden = true; return;
    }
    foot.hidden = false;
    items.innerHTML = cart.items.map(function (it, i) {
      var gift = it.properties && it.properties.Brinde;
      var variant = it.variant_title && it.variant_title !== 'Default Title' ? '<p class="line__meta">' + it.variant_title + '</p>' : '';
      var img = it.image ? '<img src="' + it.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') + '" alt="">' : '';
      var price = it.final_line_price < it.original_line_price ? '<s>' + formatMoney(it.original_line_price) + '</s>' + formatMoney(it.final_line_price) : formatMoney(it.final_line_price);
      return '<div class="line">' +
        '<a class="line__img" href="' + it.url + '">' + img + '</a>' +
        '<div class="line__info"><p class="line__title">' + it.product_title + '</p>' + variant +
        (gift ? '<span class="line__gift">🎁 Brinde: ' + gift + '</span>' : '') +
        '<p class="line__price">' + price + '</p></div>' +
        '<div class="line__side"><button type="button" class="line__remove" data-line-qty="' + (i + 1) + '" data-q="0" aria-label="Remover"><svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M3 6h18M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"/></svg></button>' +
        '<div class="qty"><button type="button" data-line-qty="' + (i + 1) + '" data-q="' + (it.quantity - 1) + '" aria-label="Diminuir">−</button><span>' + it.quantity + '</span><button type="button" data-line-qty="' + (i + 1) + '" data-q="' + (it.quantity + 1) + '" aria-label="Aumentar">+</button></div></div>' +
        '</div>';
    }).join('');

    var disc = cart.total_discount || 0;
    var dRow = $('[data-cart-discount-row]', drawer);
    dRow.hidden = disc <= 0; $('[data-cart-discount]', drawer).textContent = '− ' + formatMoney(disc);
    $('[data-cart-total]', drawer).textContent = formatMoney(cart.total_price);

    // cupom
    var codes = (cart.discount_codes || []).filter(function (d) { return d.applicable; }).map(function (d) { return d.code.toUpperCase(); });
    var manual = getCoupon();
    var form = $('[data-coupon-form]', drawer), applied = $('[data-coupon-applied]', drawer), msg = $('[data-coupon-msg]', drawer);
    var vol = codes.filter(function (c) { return VOLUME.indexOf(c) > -1; })[0];
    if (vol) {
      form.hidden = true; applied.hidden = false;
      applied.innerHTML = '<span>🐝 Desconto progressivo ' + (vol === VOL3 ? '15%' : '10%') + ' aplicado</span>';
      msg.className = 'coupon__msg'; msg.textContent = 'Cupons não se somam ao desconto progressivo.';
    } else if (manual && codes.indexOf(manual.toUpperCase()) > -1) {
      form.hidden = true; applied.hidden = false;
      applied.innerHTML = '<span>Cupom ' + manual.toUpperCase() + ' aplicado</span><button type="button" data-coupon-remove>Remover</button>';
      msg.textContent = '';
    } else {
      form.hidden = false; applied.hidden = true;
      if (!msg.classList.contains('is-error')) msg.textContent = cart.item_count === 1 ? '' : '';
    }
  }

  /* Carrinho com kit abaixo do frete grátis: oferece os adicionais que faltam. */
  var addonsData = null;
  function getAddons() {
    if (addonsData) return addonsData;
    try { addonsData = JSON.parse(($('[data-addons-data]') || {}).textContent || '[]'); } catch (e) { addonsData = []; }
    return addonsData;
  }
  function renderUpsell(cart, total) {
    var box = $('[data-cart-upsell]', drawer); if (!box) return;
    var hasKit = (cart.items || []).some(function (i) { return String(i.handle || '').indexOf('kit-') === 0; });
    var inCart = (cart.items || []).map(function (i) { return i.variant_id; });
    var list = getAddons().filter(function (a) { return inCart.indexOf(a.id) === -1; });
    if (!hasKit || total >= FREE || !list.length) { box.hidden = true; box.innerHTML = ''; return; }
    box.hidden = false;
    box.innerHTML = '<p class="drawer__upsell-title">Adicione 1 item e ganhe frete grátis</p>' + list.map(function (a) {
      return '<div class="uline">' + (a.image ? '<img src="' + a.image + '" alt="" width="44" height="44">' : '') +
        '<div class="uline__info"><p>' + a.title + '</p><span>' + (a.compare > a.price ? '<s>' + formatMoney(a.compare) + '</s> ' : '') + '<b>' + formatMoney(a.price) + '</b></span></div>' +
        '<button type="button" class="btn btn--sm" data-upsell-add="' + a.id + '">+ Adicionar</button></div>';
    }).join('');
  }
  function addUpsell(id, btn) {
    if (busy) return; setBusy(true); if (btn) btn.textContent = '...';
    api(R.cartAdd + '.js', { items: [{ id: Number(id), quantity: 1 }] })
      .then(function () {
        var a = getAddons().filter(function (x) { return x.id === Number(id); })[0];
        if (window.fbq && a) { try { window.fbq('track', 'AddToCart', { content_ids: [String(id)], content_type: 'product', value: a.price / 100, currency: 'BRL' }); } catch (e) {} }
        return getCart();
      })
      .then(syncDiscounts).then(publishDiscount).then(render)
      .catch(function (e) { toast(e.message || 'Não foi possível adicionar'); })
      .then(function () { setBusy(false); });
  }

  function refresh() {
    return getCart().then(function (c) { return syncDiscounts(c); }).then(publishDiscount).then(function (c) { render(c); return c; }).catch(function () {});
  }

  function changeLine(line, qty) {
    if (busy) return; setBusy(true);
    api(R.cartChange + '.js', { line: line, quantity: qty })
      .then(syncDiscounts).then(publishDiscount).then(render)
      .catch(function (e) { toast(e.message || 'Não foi possível atualizar o carrinho'); })
      .then(function () { setBusy(false); });
  }

  function applyCoupon(code) {
    var msg = $('[data-coupon-msg]', drawer);
    code = String(code || '').trim().toUpperCase();
    if (!code) return;
    msg.classList.remove('is-error'); msg.textContent = '';
    setBusy(true);
    getCart().then(function (cart) {
      if (cart.item_count === 0) throw new Error('Adicione um produto ao carrinho primeiro.');
      if (cart.item_count > 1) throw new Error('Cupons não podem ser usados com desconto progressivo (2+ itens).');
      if (VOLUME.indexOf(code) > -1) throw new Error('Cupom inválido ou não aplicável.');
      return api(R.cartUpdate + '.js', { discount: code });
    }).then(function (cart) {
      var hit = (cart.discount_codes || []).filter(function (d) { return d.code.toUpperCase() === code; })[0];
      if (!hit || !hit.applicable) {
        return api(R.cartUpdate + '.js', { discount: '' }).then(function (c) { setCoupon(''); render(c); throw new Error('Cupom inválido ou não aplicável.'); });
      }
      setCoupon(code); render(cart); toast('Cupom ' + code + ' aplicado!');
    }).catch(function (e) {
      msg.classList.add('is-error'); msg.textContent = e.message || 'Erro ao aplicar cupom. Tente novamente.';
    }).then(function () { setBusy(false); });
  }

  function removeCoupon() {
    setCoupon(''); setBusy(true);
    api(R.cartUpdate + '.js', { discount: '' }).then(publishDiscount).then(render).catch(function () {}).then(function () { setBusy(false); });
  }

  /* ---------- add to cart ---------- */
  function addToCart(form) {
    var btn = $('[data-add-btn]', form);
    var id = $('[data-variant-input]', form).value;
    var q = parseInt((($('input[name="quantity"]:checked', form) || $('input[name="quantity"]', form) || {}).value) || '1', 10);
    var giftBox = $('[data-gift-required="true"]', form);
    var giftInput = $('input[name="gift"]:checked', form) || $('input[type="hidden"][name="gift"]', form);
    var gift = giftInput ? giftInput.value : '';
    if (giftBox && !gift) {
      giftBox.classList.remove('is-error'); void giftBox.offsetWidth; giftBox.classList.add('is-error');
      giftBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
      toast('Escolha seu brinde');
      return;
    }
    var label = btn.textContent; btn.disabled = true; btn.textContent = 'Adicionando...';
    getCart().then(function (cart) {
      var item = { id: Number(id), quantity: q };
      if (gift) {
        if (hasGiftLine(cart)) toast('Limite de 1 brinde por pedido');
        else item.properties = { Brinde: gift };
      }
      var items = [item];
      Array.prototype.forEach.call(form.querySelectorAll('[data-addon]:checked'), function (c) { items.push({ id: Number(c.value), quantity: 1 }); });
      return api(R.cartAdd + '.js', { items: items }).then(function () { return items; });
    }).then(function (items) {
      if (window.fbq) {
        try {
          var unitC = Number(($('[data-unit-price]') || {}).dataset ? $('[data-unit-price]').dataset.unitPrice : 0) || 0;
          var value = unitC * q;
          $$('[data-addon]:checked', form).forEach(function (c) { value += Number(c.dataset.price || 0); });
          window.fbq('track', 'AddToCart', {
            content_ids: items.map(function (x) { return String(x.id); }),
            content_type: 'product_group', num_items: items.length,
            value: Math.round(value) / 100, currency: 'BRL'
          });
        } catch (e) {}
      }
      btn.textContent = '✓ Adicionado!';
      return getCart().then(syncDiscounts).then(publishDiscount).then(render);
    }).then(function () {
      openDrawer();
    }).catch(function (e) {
      toast(e.message || 'Não foi possível adicionar');
    }).then(function () {
      setTimeout(function () { btn.disabled = false; btn.textContent = label; updateAddLabel(form); }, 1500);
    });
  }

  function updateAddLabel(form) {
    var btn = $('[data-add-btn]', form); if (!btn || btn.disabled) return;
    if (form._kitUpdate) { form._kitUpdate(); return; }
    var giftBox = $('[data-gift-required="true"]', form);
    var needs = giftBox && !$('input[name="gift"]:checked', form);
    btn.textContent = needs ? 'Escolha seu brinde' : 'Adicionar ao Carrinho';
    var sticky = $('[data-sticky-add]'); if (sticky) sticky.textContent = needs ? 'Escolha seu brinde acima' : 'Adicionar ao Carrinho';
  }

  /* ---------- product page ---------- */
  function initProduct() {
    var form = $('[data-product-form]'); if (!form) return;
    initKit(form);
    form.addEventListener('submit', function (e) { e.preventDefault(); addToCart(form); });
    form.addEventListener('change', function (e) {
      if (e.target.name === 'gift') { var gb = $('.gift', form); if (gb) gb.classList.remove('is-error'); }
      if (/^option\d/.test(e.target.name)) pickVariant(form);
      updateAddLabel(form);
    });
    updateAddLabel(form);

    var submitMain = function () { if (form.requestSubmit) form.requestSubmit(); else addToCart(form); };
    $$('[data-kit-submit]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); submitMain(); }); });

    var sticky = $('[data-sticky-cta]'), stickyBtn = $('[data-sticky-add]');
    if (sticky) {
      var watch = $$('[data-sticky-watch]');
      if (watch.length && 'IntersectionObserver' in window) {
        /* Barra fixa aparece só quando nenhum botão de compra está na tela. */
        var seen = {};
        var so = new IntersectionObserver(function (es) {
          es.forEach(function (en) { seen[watch.indexOf(en.target)] = en.isIntersecting; });
          var anyVisible = Object.keys(seen).some(function (k) { return seen[k]; });
          sticky.classList.toggle('is-show', !anyVisible && window.scrollY > 200);
        }, { threshold: 0 });
        watch.forEach(function (w) { so.observe(w); });
        window.addEventListener('scroll', function () {
          var anyVisible = Object.keys(seen).some(function (k) { return seen[k]; });
          sticky.classList.toggle('is-show', !anyVisible && window.scrollY > 200);
        }, { passive: true });
      } else {
        var onScroll = function () { sticky.classList.toggle('is-show', window.scrollY > 400); };
        window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
      }
      stickyBtn.addEventListener('click', submitMain);
    }

    // galeria
    var g = $('[data-gallery]');
    if (g) {
      var slides = $$('[data-gallery-slide]', g), cur = 0;
      var go = function (i) {
        if (i < 0 || i >= slides.length) return; cur = i;
        slides.forEach(function (s, k) {
          s.classList.toggle('is-active', k === i);
          var v = s.querySelector('video');
          if (v) { try { if (k === i) { v.muted = true; v.play(); } else v.pause(); } catch (e) {} }
        });
        $$('[data-gallery-go]', g).forEach(function (b) { b.classList.toggle('is-active', Number(b.dataset.galleryGo) === i); });
      };
      g.addEventListener('click', function (e) {
        var t = e.target.closest('[data-gallery-go],[data-gallery-prev],[data-gallery-next]'); if (!t) return;
        if (t.hasAttribute('data-gallery-prev')) go(cur - 1);
        else if (t.hasAttribute('data-gallery-next')) go(cur + 1);
        else go(Number(t.dataset.galleryGo));
      });
      var sx = null, main = $('.gallery__main, .kgal__main', g);
      main.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      main.addEventListener('touchend', function (e) { if (sx === null) return; var d = sx - e.changedTouches[0].clientX; if (Math.abs(d) > 50) go(cur + (d > 0 ? 1 : -1)); sx = null; });
    }

    // frete
    var sf = $('[data-ship-form]');
    if (sf) {
      var cep = $('[data-cep]', sf), out = $('[data-ship-result]');
      cep.addEventListener('input', function () { var d = cep.value.replace(/\D/g, '').slice(0, 8); cep.value = d.length > 5 ? d.slice(0, 5) + '-' + d.slice(5) : d; out.innerHTML = ''; });
      sf.addEventListener('submit', function (e) {
        e.preventDefault();
        var c = cep.value.replace(/\D/g, '');
        if (c.length !== 8) { out.innerHTML = '<p class="ship-err">Informe um CEP válido com 8 dígitos</p>'; return; }
        var q = parseInt((($('input[name="quantity"]:checked', form) || $('input[name="quantity"]', form) || {}).value) || '1', 10);
        var unit = Number(($('[data-unit-price]') || {}).dataset.unitPrice || 0) / 100;
        var extra = 0; $$('[data-addon]:checked', form).forEach(function (c) { extra += Number(c.dataset.price || 0) / 100; });
        var b = $('button', sf); b.disabled = true; b.textContent = '...';
        fetch(BN.shippingUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', apikey: BN.shippingKey, Authorization: 'Bearer ' + BN.shippingKey },
          body: JSON.stringify({ recipientCEP: c, items: [{ quantity: q + $$('[data-addon]:checked', form).length }], subtotal: unit * q + extra })
        }).then(function (r) { return r.json(); }).then(function (data) {
          if (data && data.error) { out.innerHTML = '<p class="ship-err">' + data.error + '</p>'; return; }
          var s = (data && data.services) || [];
          if (!s.length) { out.innerHTML = '<p class="ship-err">Nenhuma opção de frete encontrada para este CEP</p>'; return; }
          /* Desconto no frete: só exibido quando configurado no tema (valor real cobrado no checkout). */
          var off = Number((($('[data-ship-calc]') || {}).dataset || {}).shipDiscount || 0);
          out.innerHTML = s.map(function (o) {
            var full = Math.round(o.price * 100), price;
            if (o.price === 0) price = 'Grátis';
            else if (off > 0) price = '<s>' + formatMoney(full) + '</s> ' + formatMoney(Math.round(o.price * (100 - off)));
            else price = formatMoney(full);
            return '<div class="ship-opt"><div>' + o.service + ' <small>' + o.carrier + ' · até ' + o.deliveryTime + (o.deliveryTime === 1 ? ' dia útil' : ' dias úteis') + '</small></div><b>' + price + '</b></div>';
          }).join('');
          if (form.hasAttribute('data-kit') && !$$('[data-addon]:checked', form).length) {
            out.innerHTML += '<p class="kcalc__hint">Com 1 adicional acima, o frete sai grátis.</p>';
          }
        }).catch(function () { out.innerHTML = '<p class="ship-err">Erro ao calcular frete. Tente novamente.</p>'; })
          .then(function () { b.disabled = false; b.textContent = 'Calcular'; });
      });
    }
  }

  /* ---------- kit: total, barra de frete grátis, botões ---------- */
  function initKit(form) {
    if (!form.hasAttribute('data-kit')) return;
    var base = Number(form.dataset.base || 0);
    var thr = Number(form.dataset.threshold || Math.round(FREE * 100));
    var inst = Number(form.dataset.inst || 0);
    var label = form.dataset.label || 'Comprar o kit';
    var ship = $('[data-kship]'), msg = $('[data-kship-msg]'), bar = $('[data-kship-bar]');
    var sPrice = $('[data-sticky-price]'), sNote = $('[data-sticky-note]');
    var hasGift = !!$('.kgift', form);
    form._kitUpdate = function () {
      var total = base, n = 0;
      $$('[data-addon]:checked', form).forEach(function (c) { total += Number(c.dataset.price || 0); n++; });
      var missing = thr - total, free = missing <= 0;
      if (ship) {
        ship.classList.toggle('is-done', free);
        msg.innerHTML = free
          ? '<strong>' + (ship.dataset.done || 'Pronto: seu frete é grátis') + '</strong>'
          : (ship.dataset.missing || 'Faltam [valor] para o frete grátis').replace('[valor]', '<strong>' + formatMoney(missing) + '</strong>');
        bar.style.width = Math.min(100, total / thr * 100) + '%';
      }
      var btn = $('[data-add-btn]', form);
      if (btn && !btn.disabled) {
        btn.textContent = n === 0 ? label + ' · ' + formatMoney(total)
          : label.replace(/\s+o\s+/i, ' ') + ' + ' + n + ' · ' + formatMoney(total);
      }
      if (sPrice) sPrice.textContent = formatMoney(total);
      if (sNote) {
        var bits = [];
        if (free) bits.push('Frete grátis');
        if (hasGift) bits.push('Brinde incluso');
        if (inst > 1 && !free) bits.push('até ' + inst + 'x sem juros');
        sNote.textContent = bits.join(' · ');
      }
    };
    form.addEventListener('change', function (e) { if (e.target.hasAttribute('data-addon')) form._kitUpdate(); });
    form._kitUpdate();
  }

  function pickVariant(form) {
    var data = $('[data-variants]'); if (!data) return;
    var variants = JSON.parse(data.textContent);
    var chosen = [1, 2, 3].map(function (n) { var el = $('input[name="option' + n + '"]:checked', form); return el ? el.value : null; });
    var v = variants.filter(function (v) { return [v.option1, v.option2, v.option3].every(function (o, i) { return !chosen[i] || o === chosen[i]; }); })[0];
    if (!v) return;
    $('[data-variant-input]', form).value = v.id;
    var p = $('[data-unit-price]'); p.dataset.unitPrice = v.price; p.textContent = formatMoney(v.price);
    [1, 2, 3].forEach(function (q) {
      var el = $('[data-tier-price="' + q + '"]', form); if (!el) return;
      var orig = v.price * q, tot = q === 3 ? Math.floor(orig * 0.85) : q === 2 ? Math.floor(orig * 0.9) : orig;
      el.innerHTML = (q > 1 ? '<s>' + formatMoney(orig) + '</s>' : '') + '<strong>' + formatMoney(tot) + '</strong>';
      var small = el.parentNode.querySelector('.tier__text small'); if (small) small.textContent = formatMoney(Math.floor(tot / q)) + ' cada';
    });
    var btn = $('[data-add-btn]', form); btn.disabled = !v.available; if (!v.available) btn.textContent = 'Indisponível';
    if (history.replaceState) history.replaceState(null, '', location.pathname + '?variant=' + v.id);
  }

  /* ---------- home effects ---------- */
  function initEffects() {
    var nav = $('[data-pill-nav]');
    if (nav) { var f = function () { nav.classList.toggle('is-scrolled', window.scrollY > 80); }; window.addEventListener('scroll', f, { passive: true }); f(); }

    var menu = $('[data-mobile-menu]');
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-menu-open]')) menu.hidden = false;
      else if (e.target.closest('[data-menu-close]')) menu.hidden = true;
    });

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) { es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); } }); }, { threshold: 0.2 });
      $$('.reveal-view,[data-word-reveal]').forEach(function (el) { io.observe(el); });
    } else { $$('.reveal-view,[data-word-reveal]').forEach(function (el) { el.classList.add('is-visible'); }); }

    // parallax hero
    var hero = $('[data-parallax]');
    if (hero && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
      var layer = $('[data-parallax-layer]', hero), fade = $('[data-parallax-fade]', hero);
      var pf = function () {
        var h = hero.offsetHeight, y = Math.min(window.scrollY, h), p = y / h;
        layer.style.transform = 'translate3d(0,' + (p * 30) + '%,0)';
        fade.style.opacity = String(Math.max(0, 1 - p / 0.8));
      };
      window.addEventListener('scroll', function () { requestAnimationFrame(pf); }, { passive: true });
    }

    // features sticky
    var fs = $('[data-features]');
    if (fs) {
      var texts = $$('[data-feature-text]', fs), imgs = $$('[data-feature-img]', fs), bars = $$('.features__progress i', fs), act = 0;
      var set = function (i) {
        act = i;
        texts.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
        bars.forEach(function (b, k) { b.classList.toggle('is-active', k === i); });
        var pv = $('[data-feature-prev]', fs), nx = $('[data-feature-next]', fs);
        if (pv) pv.disabled = i === 0; if (nx) nx.disabled = i === imgs.length - 1;
      };
      if ('IntersectionObserver' in window) {
        var fo = new IntersectionObserver(function (es) { es.forEach(function (en) { if (en.isIntersecting) set(Number(en.target.dataset.featureImg)); }); }, { threshold: 0.6 });
        imgs.forEach(function (i) { fo.observe(i); });
      }
      fs.addEventListener('click', function (e) {
        var d = e.target.closest('[data-feature-prev]') ? -1 : e.target.closest('[data-feature-next]') ? 1 : 0;
        if (!d) return; var n = Math.max(0, Math.min(imgs.length - 1, act + d)); set(n);
        imgs[n].scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
      set(0);
    }
  }

  /* ---------- boot ---------- */
  document.addEventListener('DOMContentLoaded', function () {
    drawer = $('[data-cart-drawer]');
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-cart-open]')) { e.preventDefault(); openDrawer(); return; }
      if (e.target.closest('[data-cart-close]')) { closeDrawer(); return; }
      var lq = e.target.closest('[data-line-qty]');
      if (lq) { changeLine(Number(lq.dataset.lineQty), Math.max(0, Number(lq.dataset.q))); return; }
      if (e.target.closest('[data-coupon-remove]')) { removeCoupon(); return; }
      var up = e.target.closest('[data-upsell-add]');
      if (up) { addUpsell(up.dataset.upsellAdd, up); }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });
    var cf = $('[data-coupon-form]');
    if (cf) cf.addEventListener('submit', function (e) { e.preventDefault(); applyCoupon(cf.code.value); cf.code.value = ''; });

    initEffects();
    initProduct();
    refresh();
    if ($('[data-cart-page]') && document.querySelector('.cart-page p')) { /* /cart abre a gaveta */ }
    if (location.pathname === '/cart') openDrawer();
    document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible') refresh(); });
  });
})();
